import { Typography } from "@mui/material";
import { formatPrice } from "Components/Merchant/Initiate/InitiatePaymentKeypad/utils";
import type { CurrencyCode } from "Models/CurrencyCodes";

type Props = {
  previousPricesInCents: Array<number>;
  currentPriceInCents: number;
  currencyCode: CurrencyCode | undefined;
};

export const PriceBreakdownList = ({
  previousPricesInCents,
  currentPriceInCents,
  currencyCode,
}: Props) => (
  <Typography
    variant="h6"
    color="gray"
    textAlign="center"
    height="4rem"
    sx={{ overflowY: "auto" }}
  >
    {!!previousPricesInCents.length && (
      <>
        {previousPricesInCents.map(
          (priceInCents) => `${formatPrice(priceInCents, currencyCode)} + `,
        )}
        {currentPriceInCents
          ? formatPrice(currentPriceInCents, currencyCode)
          : ""}
      </>
    )}
  </Typography>
);
